import React, { useState } from "react";
import * as R from "ramda";
import { Icon } from "antd";
import PropTypes from "prop-types";

import styled from "styled-components/macro";

const FilterTabsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  width: 100%;

  .tab {
    padding: 22px;
    background-color: #f7f9fa;
    flex: 1;
    outline: 0;
    border: 0;
    cursor: pointer;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    color: #747c84;
    font-size: 15px;

    border-right: 1px solid #e5e9ec;
    border-bottom: 1px solid #d0d6da;

    .quantity {
      font-size: 13px;
    }

    &.enabled {
      border-bottom: 0;
      border-top: 1px solid #3D64FF;
      background-color: white;
      .name {
        font-weight: bold;
      }
    }
  }
`;

const Tab = ({ name, icon, enabled, onClick, quantity = 0, ...props }) => (
  <button
    onClick={onClick}
    className={`tab ${enabled ? "enabled" : ""}`}
    {...props}
  >
    <span className="name">
      <Icon style={{ marginRight: 8 }} type={icon} /> {name}
    </span>
    <span className="quantity">{quantity}</span>
  </button>
);

const getDefault = tabs =>
  R.pipe(
    R.find(R.prop("default")),
    R.propOr(tabs[0].name, "name")
  )(tabs);

const FilterTabs = ({ tabs = [], onChangeFilter, data }) => {
  const [enabled, setEnabled] = useState(getDefault(tabs));
  return (
    <FilterTabsWrapper>
      {tabs.map(({ name, filter, ...props }) => (
        <Tab
          onClick={() => {
            onChangeFilter(filter);
            setEnabled(name);
          }}
          name={name}
          key={name}
          enabled={name === enabled}
          quantity={filter ? data.filter(filter).length : data.length}
          {...props}
        />
      ))}
    </FilterTabsWrapper>
  );
};

FilterTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      enabled: PropTypes.bool,
      filter: PropTypes.func
    })
  )
};

export default FilterTabs;
